<script>
	import EntryCollapse from '@/pages/layouts/partials/sidebar/entry-collapse.vue';
	import FormElements from '@/mixins/shared/formElements';

	export default {
		mixins: [FormElements],
		components: { EntryCollapse },
		inject: ['form'],
		props: {
			entry: {
				type: Object,
				required: true,
			}
		},
		data() {
			return {
				currentMenuItemLabel: null,
				labelPlaceholder: null,
				iconPlaceholder: null,
			}
		},
		mounted() {
			this.getCurrentMenuItemLabel();
		},
		methods: {
			getCurrentMenuItemLabel() {
				if (!this.entry.menu_item_label) {
					return;
				}

				this.currentMenuItemLabel = this.entry.menu_item_label;
				this.labelPlaceholder = this.entry.menu_item_label;
				this.iconPlaceholder = this.entry.menu_item_icon;
			},

			changePlaceholders(event) {
				let data = event.params.data;
				this.entry.menu_item_label = data.text;
				this.entry.menu_item_icon = data.icon;
				this.getCurrentMenuItemLabel();
			},

			open() {
				this.$refs.collapse.open();
			},

			close() {
				this.$refs.collapse.close();
			},
		}
	}
</script>

<template>
	<EntryCollapse ref="collapse" :entry="entry">
		<Select
			:form="form"
			:name="`entries[${entry.id}][menu_item_id]`"
			v-model="entry.menu_item_id"
			:ajax-url="route('api.v1.menu_item.list', {FieldList: 'id,text,icon'})"
			:current-value-label="currentMenuItemLabel"
			label="Menu item"
			@select2:select="changePlaceholders"
			:required="true" />

		<Input
			:form="form"
			v-model="entry.label"
			:name="`entries[${entry.id}][label]`"
			label="Label"
			:placeholder="labelPlaceholder" />

		<Icon
			:form="form"
			v-model="entry.icon"
			:name="`entries[${entry.id}][icon]`"
			label="Icoon"
			:placeholder="iconPlaceholder" />
	</EntryCollapse>
</template>